import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cb45hc3s6w: FaireBrandEntity = {
  token: "b_cb45hc3s6w",
  type: "brand",
  name: "Southern Bliss Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/b273a13c7372f23687955a68fad1f9fbbb7f05690d68419e45fd232516b66617.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed155b8f9653a895aea163088cbff18db93f0c18a4f2eca5e83d84d05ff9e0f6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b273a13c7372f23687955a68fad1f9fbbb7f05690d68419e45fd232516b66617.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed155b8f9653a895aea163088cbff18db93f0c18a4f2eca5e83d84d05ff9e0f6.jpeg",
  location: "Hattiesburg, MS, USA",
  minimumOrderDollars: 207,
  rating: 4.7,
  reviewCount: 148,
  isInsider: true,
  description:
    "Hey Y'all! Welcome to Southern Bliss Company! We manufacture and ship from South Mississippi (notice the y'all). This crazy ride began in 2016 with just two sisters, their mom and one small print press. Since then we have expanded to all 50 states, Canada and Australia. We helped start the bleached tee craze by mixing funny graphics with distressed looks, and adding both boho and grunge to make one super unique product! Southern Bliss offers graphic tees, sweatshirts, gift items and more. We pride ourself in offering unique screen printed graphics, and quality products. Each item is hand bleached and has tons of love poured into every stitch. Our bleaching process has been perfected over the years and all items are washed, dried, tagged, and individually bagged before making its way out the door.\n\nWe strive to provide a product that strikes an emotion, whether it be laughter, motivation, inspiration, love and/or confidence. We want every customer to feel the extreme comfort of wearing a Southern Bliss product while also searching for their next SB purchase. We won't call it a cult, but the desire to just have one SB product is extremely rare and our end goal for our buyers is to always leave them wanting more! \n\nOur graphic categories include but are not limited to: holiday, funny, faith based, western/boho, music/rock-n-roll, and gameday",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.798Z",
    importedBy: "entity-db-cli",
  },
};
